// extracted by mini-css-extract-plugin
export default {"sectionHeading":"StudentCompetitionsPage_sectionHeading__neJSw","section":"StudentCompetitionsPage_section__ZJUjt","filterSection":"StudentCompetitionsPage_filterSection__0d7qr"};